import { Theme } from "@aws-amplify/ui-react";

export const customTheme: Theme = {
  name: "skillbubble-theme",
  tokens: {
    colors: {
      // Primary brand colors matching landing page
      brand: {
        primary: {
          10: "#f0f9ff",
          20: "#e0f2fe",
          40: "#7dd3fc",
          60: "#3b82f6", // Main blue from landing page
          80: "#1e40af",
          90: "#1e3a8a",
          100: "#172554",
        },
      },
      // Background colors
      background: {
        primary: "#ffffff",
        secondary: "#f8fafc", // Light gray from hero section
        tertiary: "#f1f5f9",
      },
      // Border colors
      border: {
        primary: "#e2e8f0",
        secondary: "#cbd5e1",
        tertiary: "#94a3b8",
      },
      // Font colors
      font: {
        primary: "#0f172a",
        secondary: "#475569",
        tertiary: "#64748b",
        interactive: "#3b82f6",
        inverse: "#ffffff",
      },
      // Overlay colors
      overlay: {
        10: "rgba(15, 23, 42, 0.05)",
        20: "rgba(15, 23, 42, 0.1)",
        30: "rgba(15, 23, 42, 0.15)",
        40: "rgba(15, 23, 42, 0.2)",
        50: "rgba(15, 23, 42, 0.3)",
        60: "rgba(15, 23, 42, 0.4)",
        70: "rgba(15, 23, 42, 0.5)",
        80: "rgba(15, 23, 42, 0.6)",
        90: "rgba(15, 23, 42, 0.8)",
      },
    },
    // Component-specific styling
    components: {
      authenticator: {
        router: {
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
        },
        form: {
          padding: "2rem",
        },
      },
      button: {
        primary: {
          backgroundColor: "{colors.brand.primary.60}",
          color: "{colors.font.inverse}",
          _hover: {
            backgroundColor: "{colors.brand.primary.80}",
          },
          _active: {
            backgroundColor: "{colors.brand.primary.90}",
          },
        },
        link: {
          color: "{colors.brand.primary.60}",
          _hover: {
            color: "{colors.brand.primary.80}",
          },
        },
        menu: {
          backgroundColor: "{colors.background.primary}",
          _hover: {
            backgroundColor: "{colors.brand.primary.10}",
            color: "{colors.brand.primary.80}",
          },
        },
      },
      input: {
        borderColor: "{colors.border.primary}",
        _focus: {
          borderColor: "{colors.brand.primary.60}",
        },
      },
      fieldcontrol: {
        _focus: {
          borderColor: "{colors.brand.primary.60}",
        },
      },
      tabs: {
        item: {
          color: "{colors.font.secondary}",
          _active: {
            color: "{colors.brand.primary.60}",
            borderColor: "{colors.brand.primary.60}",
          },
          _hover: {
            color: "{colors.brand.primary.80}",
          },
        },
      },
    },
    // Typography
    fontSizes: {
      small: "0.875rem",
      medium: "1rem",
      large: "1.125rem",
      xl: "1.25rem",
      xxl: "1.5rem",
    },
    fontWeights: {
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
    },
    // Spacing
    space: {
      xs: "0.25rem",
      small: "0.5rem",
      medium: "1rem",
      large: "1.5rem",
      xl: "2rem",
      xxl: "3rem",
    },
    // Border radius
    radii: {
      small: "4px",
      medium: "8px",
      large: "12px",
      xl: "16px",
    },
  },
};
